import { MouseEvent, PropsWithChildren, useState } from 'react';
import { cn } from '@ds';
import { IS_DEV, IS_LOCAL, IS_PROD } from '@/constants/env.constants';
import styles from '../../CaseCard.module.scss';

const BANANA_CARD_ENABLED = true;
const IS_FUN_ENV = IS_DEV || IS_LOCAL;
export const BANANA_CARD_VISIBLE = BANANA_CARD_ENABLED && IS_FUN_ENV && !IS_PROD;

const randomInRange = (min: number, max: number) => Math.round(min + Math.random() * (max - min));

type KidneyBananaTriggerProps = {
  onActivate: () => void;
};

export const BananaTrigger = ({ onActivate }: KidneyBananaTriggerProps) => {
  const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    onActivate();
  };

  return (
    <button type="button" className={styles.kidneyTriggerButton} onClick={handleClick} aria-label="Make it banana">
      🍌
    </button>
  );
};

type GoggleBandProps = { height: number } & PropsWithChildren;

const GoggleBand = ({ height, children }: GoggleBandProps) => (
  <div className={styles.kidneyGoggleBand} style={{ height }}>
    {children}
  </div>
);

type PantsBandProps = { paddingTop: number; paddingBottom: number } & PropsWithChildren;

const PantsBand = ({ paddingTop, paddingBottom, children }: PantsBandProps) => (
  <div className={styles.kidneyPantsBand} style={{ paddingTop, paddingBottom }}>
    {children}
  </div>
);

export const KidneyBananaTop = () => {
  const [eyeCount] = useState(() => (Math.random() < 0.5 ? 1 : 2));
  const [goggleHeight] = useState(() => randomInRange(58, 88));

  return (
    <GoggleBand height={goggleHeight}>
      <div className={cn(styles.kidneyEyesRow, { [styles.kidneyEyesTwo]: eyeCount === 2 })}>
        {Array.from({ length: eyeCount }, (_, index) => (
          <div className={styles.kidneyEye} key={index}>
            <div className={styles.kidneyPupil} />
          </div>
        ))}
      </div>
    </GoggleBand>
  );
};

type KidneyBananaBottomProps = {
  onDeactivate: () => void;
};

export const KidneyBananaBottom = ({ onDeactivate }: KidneyBananaBottomProps) => {
  const [pantsPadding] = useState(() => randomInRange(6, 22));

  const handlePocketClick = (event: MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    onDeactivate();
  };

  return (
    <PantsBand paddingTop={pantsPadding} paddingBottom={pantsPadding + 4}>
      <button
        type="button"
        className={styles.kidneyPocket}
        onClick={handlePocketClick}
        aria-label="Back to normal card"
      >
        🍌
      </button>
    </PantsBand>
  );
};
